import { render, staticRenderFns } from "./EditVolunteer.vue?vue&type=template&id=203fc588&"
import script from "./EditVolunteer.vue?vue&type=script&lang=js&"
export * from "./EditVolunteer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports